import { makeScanner, listCameras } from '../qr.js';


export async function initScanPage() {
    console.log("loadScanner2")
    const video = document.getElementById('video');
    const resultEl = document.getElementById('result');
    const btnStart = document.getElementById('btn-start');
    const btnStop = document.getElementById('btn-stop');
    const btnFlip = document.getElementById('btn-flip');
    const btnTorch = document.getElementById('btn-torch');
    const cameraSelect = document.getElementById('camera-select');
    const fileInput = document.getElementById('file');
    const modalElement = document.getElementById('qrModal');
    const modalMessage = document.getElementById('qr-modal-message');
    const modalContinue = document.getElementById('qr-modal-continue');


    // Si no existe el contenedor esperado, no hacemos nada.
    if (!video || !resultEl) return;


    const setResultDisplay = (text) => { resultEl.textContent = text || '—'; };

    let modalInstance = null;
    const getModal = () => {
        if (!modalElement || !window.bootstrap?.Modal) return null;
        if (!modalInstance) {
            modalInstance = new window.bootstrap.Modal(modalElement, { backdrop: 'static', keyboard: false });
        }
        return modalInstance;
    };

    const iconMap = {
        success: 'success',
        danger: 'error',
        warning: 'warning',
        info: 'info'
    };

    const getVariantTitle = (variant) => ({
        success: 'Éxito',
        danger: 'Error',
        warning: 'Atención',
        info: 'Aviso'
    })[variant] || 'Aviso';

    const showFallbackDialog = ({ variant, message, onConfirm }) => {
        const icon = iconMap[variant] || 'info';
        if (window.Swal) {
            window.Swal.fire({
                icon,
                title: getVariantTitle(variant),
                text: message,
                confirmButtonText: onConfirm ? 'Continuar' : 'Aceptar',
                showCancelButton: typeof onConfirm === 'function',
                cancelButtonText: 'Cancelar',
                focusCancel: true
            }).then((result) => {
                if (result.isConfirmed && typeof onConfirm === 'function') onConfirm();
            });
            return;
        }

        const proceed = typeof onConfirm === 'function' ? window.confirm(`${message}\n\n¿Deseas continuar?`) : false;
        if (proceed && typeof onConfirm === 'function') onConfirm();
        if (!proceed && !onConfirm) window.alert(message);
    };

    const showModal = ({ variant, message, onConfirm }) => {
        const modal = getModal();
        if (!modal || !modalMessage || !modalContinue) {
            showFallbackDialog({ variant, message, onConfirm });
            return;
        }

        modalMessage.textContent = message;
        modalMessage.classList.remove('text-success', 'text-danger', 'text-warning', 'text-info');
        const variantClass = {
            success: 'text-success',
            danger: 'text-danger',
            warning: 'text-warning',
            info: 'text-info'
        }[variant] || 'text-info';
        modalMessage.classList.add(variantClass);

        modalContinue.onclick = () => {
            modal.hide();
            if (typeof onConfirm === 'function') onConfirm();
        };

        modal.show();
    };

    let qrScanner;
    let currentCameraId = null;
    let isProcessing = false;
    let lastCode = null;
    let lastHandledAt = 0;

    const processCode = async (rawCode) => {
        const code = rawCode?.trim();
        if (!code || isProcessing) return;
        const nowTs = Date.now();
        if (code === lastCode && nowTs - lastHandledAt < 2000) return;
        lastCode = code;
        lastHandledAt = nowTs;
        isProcessing = true;

        try {
            const response = await fetch('/api/visitors/lookup-qr', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ code }),
                credentials: 'same-origin'
            });

            let payload = null;
            try {
                payload = await response.json();
            } catch (_) {
                payload = null;
            }

            if (!response.ok || !payload?.ok) {
                const message = payload?.error || 'Código QR inválido.';
                showModal({ variant: 'danger', message });
                return;
            }

            const { visitor } = payload;
            if (!visitor?.id) {
                showModal({ variant: 'danger', message: 'Respuesta inválida del servidor.' });
                return;
            }

            const isProgramado = visitor.status === 'programado';
            const message = isProgramado
                ? `Visitante ${visitor.name || ''} encontrado (${visitor.statusDisplay}).`
                : `Visitante ${visitor.name || ''} en estado ${visitor.statusDisplay}.`;
            showModal({
                variant: isProgramado ? 'success' : 'danger',
                message,
                onConfirm: () => {
                    window.location.href = visitor.viewUrl;
                }
            });

            try { await stop(); } catch (err) { console.warn('No se pudo detener el escáner', err); }
        } catch (err) {
            console.error('Error consultando el QR del visitante', err);
            showModal({ variant: 'danger', message: 'No se pudo validar el código QR.' });
        } finally {
            isProcessing = false;
        }
    };


    const initScanner = async () => {
        if (qrScanner) return qrScanner;
        const handleDetection = (text) => {
            setResultDisplay(text);
            processCode(text);
        };
        qrScanner = makeScanner(video, handleDetection);


        const cameras = await listCameras();
        if (cameraSelect) {
            cameraSelect.innerHTML = '';
            cameras.forEach((c, i) => {
                const opt = document.createElement('option');
                opt.value = c.id;
                opt.textContent = c.label || `Cámara ${i + 1}`;
                cameraSelect.appendChild(opt);
            });
            if (cameras.length) {
                cameraSelect.disabled = false;
                currentCameraId = cameras.find(c => /back|environment/i.test(c.label))?.id || cameras[0].id;
                cameraSelect.value = currentCameraId;
            }
        }


        try { btnTorch && (btnTorch.disabled = !(await navigator.mediaDevices?.getUserMedia)); } catch { if (btnTorch) btnTorch.disabled = true; }
        return qrScanner;
    };


    const start = async () => {
        console.log("click start")
        await initScanner();
        await qrScanner.setCamera(currentCameraId || 'environment');
        await qrScanner.start();
        if (btnStart) btnStart.disabled = true;
        if (btnStop) btnStop.disabled = false;
        if (btnFlip) btnFlip.disabled = false;
        if (cameraSelect) cameraSelect.disabled = false;
        try {
            const hasTorch = await qrScanner.hasTorch();
            if (btnTorch) btnTorch.disabled = !hasTorch;
        } catch { if (btnTorch) btnTorch.disabled = true; }
    };

    const stop = async () => {
        if (!qrScanner) return;
        await qrScanner.stop();
        if (btnStart) btnStart.disabled = false;
        if (btnStop) btnStop.disabled = true;
        if (btnTorch) btnTorch.disabled = true;
    };


    btnStart?.addEventListener('click', start);
    btnStop?.addEventListener('click', stop);


    btnFlip?.addEventListener('click', async () => {
        const cams = await listCameras();
        if (!cams.length) return;
        const idx = cams.findIndex(c => c.id === currentCameraId);
        const next = cams[(idx + 1) % cams.length];
        currentCameraId = next.id;
        if (cameraSelect) cameraSelect.value = currentCameraId;
        await qrScanner.setCamera(currentCameraId);
    });


    cameraSelect?.addEventListener('change', async (e) => {
        currentCameraId = e.target.value;
        if (qrScanner) await qrScanner.setCamera(currentCameraId);
    });


    btnTorch?.addEventListener('click', async () => {
        if (!qrScanner) return;
        try {
            const on = !(qrScanner.isTorchOn ?? false);
            await qrScanner.toggleTorch(on);
            qrScanner.isTorchOn = on;
            if (btnTorch) btnTorch.textContent = on ? 'Linterna: ON' : 'Linterna';
        } catch (e) {
            console.warn('Torch no disponible', e);
        }
    });


    fileInput?.addEventListener('change', async () => {
        const file = fileInput.files?.[0];
        if (!file) return;
        try {
            const { QrScanner } = await import('qr-scanner');
            const result = await QrScanner.scanImage(file, { returnDetailedScanResult: true });
            setResultDisplay(result.data);
            await processCode(result.data);
        } catch (err) {
            setResultDisplay(`No se detectó QR: ${err?.message || err}`);
            showModal({ variant: 'danger', message: 'No se detectó un código QR válido en la imagen.' });
        }
    });

    try { await start(); } catch { }
}
